import UserDetail from 'components/User/UserDetail'
import React from 'react'
import { useSelector } from 'react-redux'
import QuestionIcon from '../../../assets/icon/Icon-question.svg'
import BaseLayout from '../../../layouts/Base/BaseLayout'

export const UserProfile = () => {
  const userDetails = useSelector((state: any) => state.users.user)
  const clientDetails = useSelector((state: any) => state.clients.client)

  React.useEffect(() => {
    // Specify how to clean up after this effect:
    return function cleanup() {
      // to stop the warning of calling setState of unmounted component
      var id = window.setTimeout(() => {}, 0)
      while (id--) {
        window.clearTimeout(id)
      }
    }
  }, [clientDetails, userDetails])

  return (
    <div>
      <BaseLayout
        pageIcon={QuestionIcon}
        pageSubtitle="Your account details"
        mainElement={
          <>
            <UserDetail
              company={clientDetails.companyName}
              userDetail={userDetails}
            />
          </>
        }
      />
    </div>
  )
}

export default UserProfile
